import CaseStudiesRootHero from "./CaseStudiesRootHero";

export default CaseStudiesRootHero;